import {
  ShimmerButton,
  ShimmerButtonWrapper,
  ShimmerDivider,
  ShimmerLabel,
  ShimmerRow,
  ShimmerTransparent,
  ShimmerTxtField,
  ShimmerWrap,
} from 'components/shimmer/utils';

const FunnelSiteShimmer = () => (
  <div className="w-100">
    <ShimmerWrap>
      <ShimmerRow>
        <ShimmerLabel />
        <ShimmerTxtField />
        <ShimmerLabel />
        <ShimmerTxtField />
      </ShimmerRow>
      <ShimmerRow>
        <ShimmerLabel />
        <ShimmerTxtField />
        <ShimmerLabel span={1.5} color="black" height={8} />
      </ShimmerRow>
      <ShimmerRow>
        <ShimmerLabel />
        <ShimmerTxtField />
        <ShimmerLabel />
        <ShimmerTxtField />
      </ShimmerRow>
      <ShimmerRow justify="start">
        <ShimmerLabel />
        <ShimmerTxtField padding={16} />
      </ShimmerRow>
      <ShimmerDivider />
      <ShimmerButtonWrapper padding={4}>
        <ShimmerTransparent />
        <ShimmerButton />
      </ShimmerButtonWrapper>
    </ShimmerWrap>
  </div>
);

export default FunnelSiteShimmer;
